Vue.component('adminDeltaCards', {
  template: templates.cardDeltaCards,
  data() {
    return {
      model: {
        edit: false,
        deltaCard: {
          id: null,
          name: null,
          description: null,
          effect: null,
          category: null,
          min_card_level: 0,
          active: false,
          image: null
        },
        deltaCards: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      deltaCardService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.image = [`${d.id}.png`];
            data[`${d.id}`] = d;
          }
          c.model.deltaCards = data;
          c.$root.$emit('deltaCards', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.deltaCards[`${id}`];

      if (id == c.model.deltaCard.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.deltaCard = {
        id: id,
        name: data.name,
        description: data.description,
        effect: data.effect,
        category: data.category,
        min_card_level: data.min_card_level || 0,
        active: data.active,
        image: data.image || null
      }
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.deltaCard;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      } else if (!data.description) {
        utils.alert.error('Description is required');
        return;
      } else if (!data.effect) {
        utils.alert.error('Effect is required');
        return;
      } else if (!data.category) {
        utils.alert.error('Category is required');
        return;
      }

      deltaCardService.save(data)
        .then(function (response) {

          if (data.id) {
            c.model.deltaCards[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.deltaCards[`${data.id}`] = data;
          }

          c.reset();

          utils.alert.success('Saved!');

        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    handleDeltaCardImageUpload(data) {
      const c = this;
      const newImage = [`${data.id}.png?t=${Date.now()}`];
      c.model.deltaCard.image = newImage;
      c.$set(c.model.deltaCards[`${data.id}`], 'image', newImage);
    },
    getDeltaCardUrl() {
      return `${root}/images/delta-cards/`;
    },
    reset() {
      const c = this;
      c.model.edit = false;

      c.model.deltaCard = {
        id: null,
        name: null,
        description: null,
        effect: null,
        category: null,
        min_card_level: 0,
        tier: 10,
        active: false,
        image: null
      }
    }
  }
});
